module.exports = __webpack_public_path__ + "static/media/man.aa922783.png";